import Enumerator from './Enumerator';

export const colorTypes = [
  'white',
  'red_900',
  'red_800',
  'red_700',
  'red_600',
  'red_500',
  'red_400',
  'red_300',
  'red_200',
  'red_100',
  'pink_900',
  'pink_800',
  'pink_700',
  'pink_600',
  'pink_500',
  'pink_400',
  'pink_300',
  'pink_200',
  'pink_100',
  'purple_900',
  'purple_800',
  'purple_700',
  'purple_600',
  'purple_500',
  'purple_400',
  'purple_300',
  'purple_200',
  'purple_100',
  'deep_purple_900',
  'deep_purple_800',
  'deep_purple_700',
  'deep_purple_600',
  'deep_purple_500',
  'deep_purple_400',
  'deep_purple_300',
  'deep_purple_200',
  'deep_purple_100',
  'indigo_900',
  'indigo_800',
  'indigo_700',
  'indigo_600',
  'indigo_500',
  'indigo_400',
  'indigo_300',
  'indigo_200',
  'indigo_100',
  'blue_900',
  'blue_800',
  'blue_700',
  'blue_600',
  'blue_500',
  'blue_400',
  'blue_300',
  'blue_200',
  'blue_100',
  'light_blue_900',
  'light_blue_800',
  'light_blue_700',
  'light_blue_600',
  'light_blue_500',
  'light_blue_400',
  'light_blue_300',
  'light_blue_200',
  'light_blue_100',
  'cyan_900',
  'cyan_800',
  'cyan_700',
  'cyan_600',
  'cyan_500',
  'cyan_400',
  'cyan_300',
  'cyan_200',
  'cyan_100',
  'teal_900',
  'teal_800',
  'teal_700',
  'teal_600',
  'teal_500',
  'teal_400',
  'teal_300',
  'teal_200',
  'teal_100',
  'green_900',
  'green_800',
  'green_700',
  'green_600',
  'green_500',
  'green_400',
  'green_300',
  'green_200',
  'green_100',
  'light_green_900',
  'light_green_800',
  'light_green_700',
  'light_green_600',
  'light_green_500',
  'light_green_400',
  'light_green_300',
  'light_green_200',
  'light_green_100',
  'lime_900',
  'lime_800',
  'lime_700',
  'lime_600',
  'lime_500',
  'lime_400',
  'lime_300',
  'lime_200',
  'lime_100',
  'yellow_900',
  'yellow_800',
  'yellow_700',
  'yellow_600',
  'yellow_500',
  'yellow_400',
  'yellow_300',
  'yellow_200',
  'yellow_100',
  'amber_900',
  'amber_800',
  'amber_700',
  'amber_600',
  'amber_500',
  'amber_400',
  'amber_300',
  'amber_200',
  'amber_100',
  'orange_900',
  'orange_800',
  'orange_700',
  'orange_600',
  'orange_500',
  'orange_400',
  'orange_300',
  'orange_200',
  'orange_100',
  'deep_orange_900',
  'deep_orange_800',
  'deep_orange_700',
  'deep_orange_600',
  'deep_orange_500',
  'deep_orange_400',
  'deep_orange_300',
  'deep_orange_200',
  'deep_orange_100',
  'brown_900',
  'brown_800',
  'brown_700',
  'brown_600',
  'brown_500',
  'brown_400',
  'brown_300',
  'brown_200',
  'brown_100',
  'grey_900',
  'grey_800',
  'grey_700',
  'grey_600',
  'grey_500',
  'grey_400',
  'grey_300',
  'grey_200',
  'grey_100',
  'blue_grey_900',
  'blue_grey_800',
  'blue_grey_700',
  'blue_grey_600',
  'blue_grey_500',
  'blue_grey_400',
  'blue_grey_300',
  'blue_grey_200',
  'blue_grey_100'
];

export class ColorType extends Enumerator {
  static default() {
    return this.of('white');
  }

  title() {
    return String(this.name).replace(/[_]+/gi, '-');
  }
}
ColorType.initEnum(colorTypes);

export default {
  colorTypes,
  ColorType
};
